// extracted by mini-css-extract-plugin
export default {"container":"style_container__XtPj5","text":"style_text__KuVzz","subText":"style_subText__+mviw"};